<template>
  <div class="p-col-12">
    <page-header title="dataTable.quick-protocol-create.title" :actions="pageActions"/>
    <ancestryline-data-table :data-function="dataFunction" :default-filter="filters" :columns="columns" ref="quickprotocoldatatable"/>
  </div>
</template>

<script>
import AncestrylineDataTable from "@/components/table/AncestrylineDataTable";
import FrontBusiness from "@/business/FrontBusiness";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import PageHeader from "@/components/page/PageHeader";
import Audit from "@/viewer/user/Audit";
import DialogService from "@/business/ModalBusiness";
import QuickProtocolCreateBusiness from "@/business/QuickProtocolCreateBusiness";
import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";
import ModalQuickProtocolFilter from "@/viewer/quickProtocol/ModalQuickProtocolFilter";

export default {
  name: "QuickProtocolCreateList",
  components: {PageHeader, AncestrylineDataTable},

  data() {
    return {
      dataFunction: QuickProtocolCreateBusiness.pagination,
      filters: {name: null, isActive: null},
      columns: [
        {field: "name", header: 'dataTable.quick-protocol-create.columns.name', sortable:true},
        {field: "active", header: 'dataTable.quick-protocol-create.columns.active', sortable:true, type: 'boolean'},
        {field: "actions", header: 'dataTable.actions', sortable:false, type: 'actions', style: 'width: 100px',
          actions: [
            {icon: 'pi pi-pencil', title: 'dataTable.quick-protocol-create.columns.edit', function: this.editQuickProtocolCreate},
            {icon: 'pi pi-trash', title: 'dataTable.quick-protocol-create.columns.delete', function: this.deleteQuickProtocolCreate, refreshList: true},
          ]
        },
      ],
      pageActions: [
        {icon: 'pi pi-filter', label: 'dataTable.quick-protocol-create.filters', function: this.openFilterModal, type: 'button'},
        {icon: 'pi pi-plus', label: 'dataTable.quick-protocol-create.add', url: '/quick-protocol-create'},
        {icon: 'pi pi-eye', label: 'audit.button-list', function: this.openModal, type: 'button'},
      ],
    }
  },

  methods: {

    editQuickProtocolCreate(quickProtocolCreate){
      FrontBusiness.redirect(`/quick-protocol-create/${quickProtocolCreate.id}`);
    },

    async deleteQuickProtocolCreate(quickProtocolCreate, dataList){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)) {
        const response = await QuickProtocolCreateBusiness.delete(quickProtocolCreate.id).catch((e) => ToastMessageBusiness.showError(e.message));
        if (response) {
          dataList = dataList.filter(c => c.id !== quickProtocolCreate.id);
          ToastMessageBusiness.showSuccess();
        }
        return dataList;
      }
    },

    openModal(){
      DialogService.openModal(Audit, {business: QuickProtocolCreateBusiness});
    },

    async openFilterModal(){
      const filters = await DialogService.openModal(ModalQuickProtocolFilter, {filters: this.filters});
      console.log(filters);
      if(filters){
        this.$set(this.$refs.quickprotocoldatatable, 'filters', {filters});
        this.$set(this, 'filters', filters);
        await this.$refs.quickprotocoldatatable.loadPage();
      }
    },

  }

}
</script>

<style scoped>

</style>